export default __webpack_public_path__ + "static/media/Vector-1.c67dac7e.svg";